(function(){
  const BRAND_PRIORITY=Object.freeze({SKF:10,NACHI:20,FAG:30,TIMKEN:40,NAZ:50});
  const BRAND_ALIASES=Object.freeze({ECO:'NAZ'});
  const SEAL_ALIASES=Object.freeze({'2Z':'ZZ',RS:'2RS'});

  function normalize(value){
    return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().trim().replace(/[^A-Z0-9]+/g,' ').replace(/\s+/g,' ');
  }
  function normalizeBrand(value){
    const brand=normalize(value);
    return BRAND_ALIASES[brand]||brand;
  }
  function brandRank(brand){ return BRAND_PRIORITY[normalizeBrand(brand)]||100; }
  function sealMatches(querySeal,family){
    const expected=normalize(querySeal),actual=normalize(family).split(' ').slice(1).join(' ');
    if(!expected)return true;
    if(expected==='2RS')return actual==='2RS';
    return actual===expected;
  }

  function technicalQuery(value){
    const normalized=normalize(value);
    let tokens=normalized.split(' ').filter(Boolean);
    if(tokens.length===1){
      const compact=tokens[0].match(/^(\d{3,5})([A-Z][A-Z0-9]*)$/);
      if(compact)tokens=[compact[1],compact[2]];
    }
    const base=tokens[0]||'';
    if(!/^\d{3,5}$/.test(base))return null;
    let seal='',preferred='';
    for(const token of tokens.slice(1)){
      const canonicalBrand=normalizeBrand(token);
      if(Object.hasOwn(BRAND_PRIORITY,canonicalBrand)){if(preferred&&preferred!==canonicalBrand)return null;preferred=canonicalBrand;continue;}
      const canonicalSeal=SEAL_ALIASES[token]||token;
      if(!/^[A-Z0-9]+$/.test(canonicalSeal)||seal)return null;
      seal=canonicalSeal;
    }
    return {base,seal,preferred,family:seal?base+' '+seal:''};
  }

  function sortBrandList(list){
    const activeSort=normalize(list.dataset.sdSort);
    if(activeSort&&activeSort!=='RELEVANCE')return;
    const allChildren=Array.from(list.children);
    const items=allChildren.filter(item=>item.hasAttribute('data-sd-brand'));
    if(!items.length)return;
    const hasQuery=list.hasAttribute('data-sd-query');
    const parsed=hasQuery?technicalQuery(list.dataset.sdQuery):null;
    if(hasQuery&&!parsed){list.dataset.sdTechnicalQuery='false';list.dataset.sdOrderReady='true';return;}
    const preferred=parsed?.preferred||normalizeBrand(list.dataset.sdPreferredBrand);
    const groups=new Map();

    const records=items.map((item,index)=>{
      const family=normalize(item.dataset.sdFamily);
      const base=normalize(item.dataset.sdBase)||family.split(' ')[0]||'';
      const brand=normalizeBrand(item.dataset.sdBrand);
      const familyLink=item.hasAttribute('data-sd-family-link');
      const matched=!parsed||(base===parsed.base&&sealMatches(parsed.seal,family));
      const groupKey=family||'__item_'+index;
      if(matched&&!groups.has(groupKey))groups.set(groupKey,index);
      item.hidden=!matched;
      return {item,index,family,base,brand,familyLink,matched,groupKey};
    });

    if(parsed)allChildren.filter(item=>!item.hasAttribute('data-sd-brand')).forEach(item=>{item.hidden=true;});

    const visible=records.filter(record=>record.matched);
    visible.sort((a,b)=>{
      if(a.groupKey!==b.groupKey){
        if(!parsed)return groups.get(a.groupKey)-groups.get(b.groupKey);
        if(!parsed.seal){
          const sealRank=(family)=>family.endsWith(' 2RS')?10:family.endsWith(' ZZ')?20:30;
          const difference=sealRank(a.family)-sealRank(b.family);
          if(difference!==0)return difference;
        }
        return groups.get(a.groupKey)-groups.get(b.groupKey);
      }
      if(a.familyLink!==b.familyLink)return a.familyLink?-1:1;
      if(preferred){
        const preferredA=a.brand===preferred,preferredB=b.brand===preferred;
        if(preferredA!==preferredB)return preferredA?-1:1;
      }
      const rankDifference=brandRank(a.brand)-brandRank(b.brand);
      return rankDifference||a.index-b.index;
    });

    const fragment=document.createDocumentFragment();
    visible.forEach(record=>fragment.appendChild(record.item));
    list.appendChild(fragment);
    list.dataset.sdTechnicalQuery=parsed?'true':'false';
    list.dataset.sdOrderReady='true';
  }

  function sortBrandElements(root=document){
    root.querySelectorAll('[data-sd-brand-list]').forEach(sortBrandList);
  }

  window.SDBrandOrder={priority:BRAND_PRIORITY,aliases:BRAND_ALIASES,normalize,normalizeBrand,technicalQuery,sealMatches,brandRank,sortBrandElements};
})();
